export default "__VITE_ASSET__CjJ3hela__"